const KEY_STORAGE = "bk_loyalty_key";

/** Device key proves this phone belongs to this device, unlocking name/history. */
export const loyaltyKeyParam = () => {
  const k = localStorage.getItem(KEY_STORAGE);
  return k ? `?k=${encodeURIComponent(k)}` : "";
};

export const rememberLoyaltyKey = (data) => {
  if (data?.access_key) localStorage.setItem(KEY_STORAGE, data.access_key);
};

export const forgetLoyaltyKey = () => localStorage.removeItem(KEY_STORAGE);
